<div>
  <footer>
    <nav
      style="padding-left: 5px; padding-right: 5px"
      class="navbar navbar-toodle d-flex align-items-center"
      [ngStyle]="
        Merchant.multi_outlet
          ? {
              'border-top':
                Merchant?.menu_border_width +
                'px solid ' +
                Merchant?.menu_border_color,
            }
          : {
              'border-top':
                Merchant?.webapp_settings?.menu_border_width +
                'px solid ' +
                Merchant.webapp_settings?.menu_border_color,
            }
      "
    >
      <!-- ======================================== -->
      <!-- Back button -->
      <!-- ======================================== -->

      @if (!Home) {
        @if (!IsSingleOutletHome) {
          <div
            class="text-white col-2"
            style="cursor: pointer"
            (click)="GoBack()"
          >
            <img
              src="assets/img/back_arrow.png"
              alt="back"
              width="30px"
              height="30px"
            />
          </div>
        }
      }

      <!-- ======================================== -->
      <!-- Profile - Home / Single Outlet -->
      <!-- ======================================== -->

      @if (Home && !Merchant.multi_outlet) {
        <div class="col-1 ml-0" style="padding-left: 0px; cursor: pointer">
          <div (click)="VisitProfile()">
            <img
              src="assets/img/profile_white.png"
              alt="profile"
              width="30"
              height="30"
            />
          </div>
        </div>
      }

      <!-- ======================================== -->
      <!-- Home / Store Info -->
      <!-- ======================================== -->

      @if (!Home) {
        @if (IsSingleOutletHome) {
          <div class="col-2 ml-0" style="padding-left: 0px; cursor: pointer">
            <div (click)="StoreInfo(StoreInfopop); $event.stopPropagation()">
              <img
                src="assets/img/venue_home_button.png"
                alt="home"
                width="30px"
                height="30px"
              />
            </div>
          </div>
        }

        @if (Merchant.multi_outlet) {
          <div class="col-2 ml-0" style="padding-left: 0px; cursor: pointer">
            <div (click)="StoreInfo(StoreInfopop); $event.stopPropagation()">
              <img
                src="assets/img/venue_home_button.png"
                alt="home"
                width="30px"
                height="30px"
              />
            </div>
          </div>

        } @else if (!IsSingleOutletHome) {
          <div class="col-2 ml-0" style="padding-left: 0px; cursor: pointer">
            <div (click)="GoToOutletHome(); $event.stopPropagation()">
              <img
                src="assets/img/home_button.png"
                alt="home"
                width="30px"
                height="30px"
              />
            </div>
          </div>
        }
      }

      <!-- ======================================== -->
      <!-- LEFT SECTION -->
      <!-- Language + Install -->
      <!-- ======================================== -->

      <div class="footer-left">
        <!-- ======================================== -->
        <!-- Language Selector -->
        <!-- ======================================== -->

        @if (Home) {
          <div class="language-selector notranslate" translate="no">
            <!-- Visible Unicode flag -->
            <span
              class="language-flag"
              [attr.aria-label]="selectedLanguage || 'Language'"
            >
              {{ selectedLanguageFlag }}
            </span>

            <!-- Actual language selector -->
            <select
              class="language-select"
              #selectControl
              [value]="selectedLanguage"
              (change)="onSelectChange(selectControl.value)"
              aria-label="Select language"
            >
              <option value="">Language</option>
              <option value="ar">Arabic</option>
              <option value="km">Cambodian</option>
              <option value="nl">Dutch</option>
              <option value="en">English</option>
              <option value="fr">French</option>
              <option value="de">German</option>
              <option value="el">Greek</option>
              <option value="hi">Hindi</option>
              <option value="id">Indonesian</option>
              <option value="it">Italian</option>
              <option value="lo">Lao</option>
              <option value="ms">Malaysian</option>
              <option value="pt">Portuguese</option>
              <option value="ru">Russian</option>
              <option value="es">Spanish</option>
              <option value="th">Thai</option>
              <option value="vi">Vietnamese</option>
            </select>
          </div>
        }

        <!-- ======================================== -->
        <!-- Install Button -->
        <!-- ======================================== -->
        @if (
          showInstallButton &&
          (Merchant?.enable_pwa_install_button ||
            Merchant?.webapp_settings?.enable_pwa_install_button) &&
          !coreService.isStandalone &&
          (coreService.canInstallAndroid || coreService.isIOS)
        ) {
          <div
            class="install-app-btn"
            (click)="onInstallClick(iOSInstallModal)"
          >
            <img src="assets/img/install_button.png" alt="Install" />
          </div>
        }
      </div>

      <!-- ======================================== -->
      <!-- CENTER SECTION -->
      <!-- Basket / Profile -->
      <!-- ======================================== -->

      <div class="footer-middle">
        <div
          class="basket-profile-area"
          style="padding-left: 0px; cursor: pointer"
        >
          @if (!Merchant.multi_outlet) {
            @if (
              (basket$ | async)?.items.length > 0 &&
              ((!Merchant?.webapp_settings?.is_non_clickable_product &&
                !Merchant?.webapp_settings?.is_non_clickable_product_outlet) ||
                (IsMultiOutlet &&
                  !Merchant?.webapp_settings
                    ?.is_non_clickable_product_multi_outlet))
            ) {
              <!-- ======================================== -->
              <!-- Basket -->
              <!-- ======================================== -->

              <div
                class="d-flex align-items-center basket-btn"
                (click)="OpenBasket()"
                [style.border]="
                  (Merchant.webapp_settings?.menu_border_width ?? 0) / 2 +
                  'px solid #fff'
                "
              >
                <!-- Basket Icon -->

                <div class="basket-icon-wrapper">
                  <img
                    src="assets/img/basket.png"
                    alt="basket"
                    width="30"
                    height="30"
                  />

                  <!-- Basket Count -->

                  <span class="count notranslate">
                    {{ basketCount }}
                  </span>
                </div>

                <!-- Basket Amount -->

                <span class="amount">
                  <span class="currency notranslate">
                    {{ Merchant?.currency }}
                  </span>

                  <span class="total-value notranslate">
                    {{ (basket$ | async)?.orderTotal | currencyFormat: Merchant?.currency_decimals }}
                  </span>
                </span>
              </div>
            }

          } @else {
            @if (Home && Merchant.multi_outlet) {
              <!-- Multi Outlet Profile -->

              <div class="ml-0 cursor-pointer" (click)="VisitProfile()">
                <img
                  src="assets/img/profile_white.png"
                  alt="profile"
                  width="30px"
                  height="30px"
                />
              </div>
            }
          }
        </div>
      </div>

      <!-- ======================================== -->
      <!-- RIGHT SECTION -->
      <!-- Powered By Logo -->
      <!-- ======================================== -->

      <div class="col-3 pr-0 footer-logo" style="padding-right: 0px">
        <p class="heading m-0">
          <span class="navbar-brand" style="float: right" aria-label="logo">
            <img
              src="assets/img/toodle_logo_powered.png"
              alt="logo"
              style="height: 30px; width: auto"
            />
          </span>
        </p>
      </div>
    </nav>
  </footer>

  <!-- ======================================== -->
  <!-- Store Info Modal -->
  <!-- ======================================== -->

  <ng-template #StoreInfopop let-modal>
    <div class="modal-body">
      <div class="justify-content-center box" style="width: 100%">
        <div
          class="about-content text-center mb-2"
          style="white-space: break-spaces"
        >
          <h2>ALERT</h2>
        </div>

        <br />

        <p
          class="mt-2 mb-0 allow-break-line"
          [ngStyle]="{
            color: Merchant?.menu_font_color_allpage,
          }"
        >
          If you click Proceed you will leave this outlet and return to the
          VENUE home-screen.
        </p>

        <p
          class="mt-2 mb-0 allow-break-line"
          [ngStyle]="{
            color: Merchant?.menu_font_color_allpage,
          }"
        >
          If you wish to continue browsing this outlet then click Stay here.
        </p>

        <p
          class="mt-2 mb-0 allow-break-line"
          [ngStyle]="{
            color: Merchant?.menu_font_color_allpage,
          }"
        ></p>

        <p
          class="mt-2 mb-0 allow-break-line"
          [ngStyle]="{
            color: Merchant?.menu_font_color_allpage,
          }"
        >
          (Tip: Use the back button to navigate to the outlet homescreen)
        </p>
      </div>
    </div>

    <div class="modal-footer" [ngStyle]="{ display: 'block' }">
      <div class="d-grid">
        <!-- Proceed -->

        <button
          type="button"
          [ngStyle]="{
            color: Merchant?.webapp_settings?.menu_font_color_homepgae,
            backgroundColor: Merchant?.webapp_settings?.menu_color,
            border:
              Merchant?.webapp_settings?.menu_border_width +
              'px solid ' +
              Merchant?.webapp_settings?.menu_border_color,
          }"
          class="btn btn-accent-theme btn-lg mt-2"
          (click)="GoToHome()"
        >
          Proceed
        </button>

        <!-- Stay Here -->

        <button
          type="button"
          [ngStyle]="{
            color: Merchant?.webapp_settings?.menu_font_color_homepgae,
            backgroundColor: Merchant?.webapp_settings?.menu_color,
            border:
              Merchant?.webapp_settings?.menu_border_width +
              'px solid ' +
              Merchant?.webapp_settings?.menu_border_color,
          }"
          class="btn btn-accent-theme btn-lg mt-2"
          (click)="modal.close('Close click')"
        >
          Stay here
        </button>
      </div>
    </div>
  </ng-template>

  <!-- ======================================== -->
  <!-- iOS Install Modal -->
  <!-- ======================================== -->

  <ng-template #iOSInstallModal let-modal>
    <!-- Header -->

    <div
      class="modal-header"
      [ngStyle]="{
        'justify-content': 'right',
        height: '40px',
        backgroundColor:
          Merchant?.webapp_settings?.menu_color ?? Merchant?.menu_color,
        'border-bottom':
          (Merchant?.webapp_settings?.menu_border_width ??
            Merchant?.menu_border_width) +
          'px solid ' +
          (Merchant?.webapp_settings?.menu_border_color ??
            Merchant?.menu_border_color),
      }"
    >
      <a (click)="modal.close()" class="close-icon" style="cursor: pointer">
        <i
          class="zmdi zmdi-close zmdi-hc-fw"
          [ngStyle]="{
            color:
              Merchant?.webapp_settings?.menu_font_color_homepgae ??
              Merchant?.menu_font_color_homepgae,
          }"
        ></i>
      </a>
    </div>

    <!-- Body -->

    <div class="modal-body">
      <h5
        class="text-center mb-3"
        [ngStyle]="{
          color:
            Merchant?.webapp_settings?.menu_font_color_allpage ??
            Merchant?.menu_font_color_allpage,
        }"
      >
        Install App
      </h5>

      <p
        [ngStyle]="{
          color:
            Merchant?.webapp_settings?.menu_font_color_allpage ??
            Merchant?.menu_font_color_allpage,
        }"
      >
        To install this app on your iPhone:
      </p>

      <ol
        style="padding-left: 20px"
        [ngStyle]="{
          color:
            Merchant?.webapp_settings?.menu_font_color_allpage ??
            Merchant?.menu_font_color_allpage,
        }"
      >
        <li class="mb-3">
          Tap the <strong>More</strong> button in the Safari address bar (either
          the <strong>(⋯)</strong> button on the right or the
          <strong>(≡)</strong> button on the left of the URL).
        </li>

        <li class="mb-3">
          Select <strong>Share</strong> from the options menu.
        </li>

        <li>
          Scroll down and tap
          <strong>Add to Home Screen</strong>.
        </li>
      </ol>
    </div>

    <!-- Footer -->

    <div class="modal-footer" [ngStyle]="{ display: 'block' }">
      <div class="d-grid">
        <button
          class="btn btn-accent-theme btn-lg mt-2"
          [ngStyle]="{
            color:
              Merchant?.webapp_settings?.menu_font_color_homepgae ??
              Merchant?.menu_font_color_homepgae,

            backgroundColor:
              Merchant?.webapp_settings?.menu_color ?? Merchant?.menu_color,

            border:
              (Merchant?.webapp_settings?.menu_border_width ??
                Merchant?.menu_border_width) +
              'px solid ' +
              (Merchant?.webapp_settings?.menu_border_color ??
                Merchant?.menu_border_color),
          }"
          (click)="modal.close()"
        >
          Got it
        </button>
      </div>
    </div>
  </ng-template>
</div>

<!-- ======================================== -->
<!-- Login Options Popup -->
<!-- ======================================== -->

<app-popup-login-options
  [Merchant$]="Merchant"
  [Show]="ShowLoginOption"
  [ShowSkipOption]="false"
  [FromMultiOutlet]="FromMultiOutlet"
  [FromSingleOutlet]="FromSingleOutlet"
  (Close)="closeOptionPopup()"
></app-popup-login-options>

<!-- ======================================== -->
<!-- CSS -->
<!-- ======================================== -->

<style>
  /* ======================================== */
  /* MAIN FOOTER */
  /* ======================================== */

  .navbar-toodle {
    display: flex;
    align-items: center;

    width: 100%;

    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: calc(10px + env(safe-area-inset-bottom));

    position: fixed;
    bottom: 0;

    max-width: 480px;

    /* Important */
    position: fixed;
  }

  /* ======================================== */
  /* LEFT SECTION */
  /* Flag + Install */
  /* ======================================== */

  .footer-left {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    flex: 0 0 auto;

    gap: 0;

    position: relative;

    z-index: 2;
  }

  /* ======================================== */
  /* LANGUAGE SELECTOR */
  /* ======================================== */

  .language-selector {
    position: relative;

    width: 40px;
    height: 35px;

    padding: 0 !important;
    margin: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;

    flex-shrink: 0;
  }

  /* ======================================== */
  /* LANGUAGE FLAG */
  /* ======================================== */

  .language-flag {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 35px;
    height: 35px;

    font-size: 25px;
    line-height: 1;

    pointer-events: none;
    user-select: none;
  }

  /* ======================================== */
  /* LANGUAGE SELECT */
  /* ======================================== */

  .language-select {
    position: absolute;

    top: 0;
    left: 0;

    width: 40px;
    height: 35px;

    margin: 0;
    padding: 0;

    opacity: 0;

    cursor: pointer;

    z-index: 10;
  }

  /* ======================================== */
  /* INSTALL BUTTON */
  /* ======================================== */

  .install-app-btn {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 35px;
    height: 35px;

    margin: 0;

    flex: 0 0 35px;

    cursor: pointer;

    z-index: 5;
  }

  .install-app-btn img {
    display: block;

    width: 28px;
    height: 29px;
  }

  /* ======================================== */
  /* CENTER SECTION */
  /* Basket */
  /* ======================================== */

  .footer-middle {
    position: absolute;

    left: 50%;

    transform: translateX(-50%);

    display: flex;
    align-items: center;
    justify-content: center;

    width: max-content;
    min-width: max-content;

    z-index: 3;
  }

  /* ======================================== */
  /* BASKET / PROFILE */
  /* ======================================== */

  .basket-profile-area {
    display: flex;
    align-items: center;
    justify-content: center;

    flex: 0 0 auto;

    min-width: max-content;
  }

  /* ======================================== */
  /* BASKET */
  /* ======================================== */

  .basket-btn {
    display: flex;
    align-items: center;
    justify-content: center;

    white-space: nowrap;

    min-width: max-content;

    padding: 3px 5px 6px;

    border-radius: 25px;
  }

  /* ======================================== */
  /* BASKET ICON */
  /* ======================================== */

  .basket-icon-wrapper {
    position: relative;

    width: 30px;
    height: 30px;

    flex: 0 0 30px;
  }

  .basket-icon-wrapper img {
    display: block;

    width: 30px;
    height: 30px;
  }

  /* ======================================== */
  /* BASKET COUNT */
  /* ======================================== */

  .basket-icon-wrapper .count {
    position: absolute;

    top: -5px;
    right: -7px;

    min-width: 16px;
    height: 16px;

    padding: 0 4px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 50%;

    background: red;
    color: white;

    font-size: 10px;
    line-height: 16px;
    font-weight: 600;

    white-space: nowrap;

    z-index: 2;
  }

  /* ======================================== */
  /* BASKET AMOUNT */
  /* ======================================== */

  .basket-btn .amount {
    display: flex;
    align-items: center;

    gap: 4px;

    margin-left: 8px;

    white-space: nowrap;

    line-height: 1;
  }

  .basket-btn .currency,
  .basket-btn .total-value {
    white-space: nowrap;
  }

  /* ======================================== */
  /* RIGHT LOGO */
  /* ======================================== */

  .footer-logo {
    margin-left: auto;

    flex: 0 0 25%;

    padding-right: 0 !important;

    position: relative;

    z-index: 2;
  }

  /* ======================================== */
  /* EXISTING LOGO */
  /* ======================================== */

  footer .navbar .navbar-brand > img {
    margin: -0.5rem 0;

    width: 35px;
  }

  /* ======================================== */
  /* TITLE */
  /* ======================================== */

  .toodle-title {
    float: right;

    font-size: 0.6rem;

    padding-top: 16px;
  }

  /* ======================================== */
  /* OTHER */
  /* ======================================== */

  .d-flex1 {
    display: block;
  }
</style>
